import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, apiErrorMessage } from "@/api/client";

const AdminAuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("lp_admin_token"));
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!token) {
      setMe(null);
      return;
    }
    try {
      const { data } = await api.get("/admin/me");
      setMe(data);
    } catch {
      localStorage.removeItem("lp_admin_token");
      setToken(null);
      setMe(null);
    }
  }, [token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("lp_admin_token", data.token);
      setToken(data.token);
      setMe({ email: data.email, role: data.role });
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErrorMessage(e) };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("lp_admin_token");
    setToken(null);
    setMe(null);
  }, []);

  const value = useMemo(() => ({ token, me, loading, login, logout }), [token, me, loading, login, logout]);
  return <AdminAuthCtx.Provider value={value}>{children}</AdminAuthCtx.Provider>;
}

export const useAdminAuth = () => useContext(AdminAuthCtx);
